import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import PremiumRoute from './components/PremiumRoute';
import Dashboard from './pages/Dashboard';
import Subscribe from './pages/Subscribe';
import Waltz from './pages/Waltz';
import Mackinder from './pages/Mackinder';
import Mackinder01 from './pages/Mackinder01';
import Mackinder02 from './pages/Mackinder02';
import Mackinder03 from './pages/Mackinder03';
import MackSpyman04 from './pages/MackSpyman04';
import Mackinder05 from './pages/Mackinder05';
import Spykman from './pages/Spykman';
import Rimland2 from './pages/Rimland2';
import HeartlandLeaflet from './pages/HeartlandLeaflet';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import SeguridadNacional2025 from './pages/SeguridadNacional2025';
import SeguridadNacionalAnalisis from './pages/SeguridadNacionalAnalisis';
import ConsejosSabios from './pages/ConsejosSabios';
import Mahan01 from './pages/Mahan01';
import Mahan02 from './pages/Mahan02';
import SistemaDefensivoInfografia from './components/SistemaDefensivoInfografia';
import Login from './pages/admin/Login';
import AdminDashboard from './pages/admin/AdminDashboard';
import BlogList from './pages/admin/BlogList';
import BlogForm from './pages/admin/BlogForm';
import ActivateSubscription from './pages/admin/ActivateSubscription';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/subscribe" element={<Subscribe />} />
          
          {/* Rutas de Contenido - Acceso Libre */}
          <Route path="/waltz" element={<Waltz />} />
          <Route path="/mackinder" element={<Mackinder />} />
          <Route path="/mackinder01" element={<Mackinder01 />} />
          <Route path="/mackinder02" element={<Mackinder02 />} />
          <Route path="/mackinder03" element={<Mackinder03 />} />
          <Route path="/mackspyman04" element={<MackSpyman04 />} />
          <Route path="/mackinder05" element={<Mackinder05 />} />
          <Route path="/spykman" element={<Spykman />} />
          <Route path="/rimland2" element={<Rimland2 />} />
          <Route path="/heartland-leaflet" element={<HeartlandLeaflet />} />
          
          {/* Seguridad Nacional Routes - Acceso Libre */}
          <Route path="/seguridad-nacional-2025" element={<SeguridadNacional2025 />} />
          <Route path="/seguridad-nacional-analisis" element={<SeguridadNacionalAnalisis />} />
          <Route path="/sistema-defensivo" element={<SistemaDefensivoInfografia />} />
          
          {/* Consejos de los Sabios Route - Acceso Libre */}
          <Route path="/consejos-sabios" element={<ConsejosSabios />} />
          
          {/* Mahan Routes - Acceso Libre */}
          <Route path="/mahan01" element={<Mahan01 />} />
          <Route path="/mahan02" element={<Mahan02 />} />
          
          {/* Blog Routes */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
          <Route path="/admin/blog" element={<PrivateRoute><BlogList /></PrivateRoute>} />
          <Route path="/admin/blog/create" element={<PrivateRoute><BlogForm /></PrivateRoute>} />
          <Route path="/admin/blog/edit/:id" element={<PrivateRoute><BlogForm /></PrivateRoute>} />
          <Route path="/admin/activate-subscription" element={<PrivateRoute><ActivateSubscription /></PrivateRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
